import type {
  BidderInvoicePaymentContext,
  InvoiceCheckoutMode,
  InvoicePaymentStatus,
  PaymentMethod,
} from '@neon-one/auctions-types';

export const SpendingMode = { PreClose: 'pre-close', PostClose: 'post-close' } as const;
export type SpendingMode = typeof SpendingMode[keyof typeof SpendingMode];

export interface MyBidsInvoiceSnapshot extends BidderInvoicePaymentContext {
  uuid: string;
  totalCents: number;
  refundedCents?: number;
  paymentStatus: InvoicePaymentStatus;
  checkoutMode?: InvoiceCheckoutMode | null;
  paymentMethod: PaymentMethod | null;
  paymentReference: string | null;
}
